import * as Yup from 'yup'

const schema = Yup.object().shape({
	username: Yup.string().required('Username harus diisi'),
	captcha: Yup.string().nullable().required('Captcha harus dipilih'),
})

export default schema
